export default {
  name: 'MessageBox',
  props: ['btns'],
  data () {
    return {
      data: null,
      title: '',
      message: ''
    }
  },
  computed: {
    defaultBtns () {
      return ['confirm', 'cancel'];
    }
  },
  methods: {
    show (data, title, message) {
      this.data = data;
      this.title = title;
      this.message = message;
      this.$refs['modal-window'].show();
    },
    displayBtn (btn) {
      if (this.btns) {
        if (this.btns.includes(btn)) {
          return true;
        }
      } else if (this.defaultBtns.includes(btn)) {
        return true;
      }
      return false;
    },
    confirm () {
      this.$emit('confirm', this.data);
      this.$refs['modal-window'].hide();
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
